<div class="container my-5">
  <h1 class="main-title">{{ 'CATEGORIES.TITLE' | translate }}</h1>
  <div class="row g-4 justify-content-center">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let item of categories"
      (click)="goToProductsByCategory(item.name)">
      <div class="category-card">
        <img [src]="item.img" [alt]="item.name" class="category-image" />
        <div class="item-label">{{ item.name | uppercase }}</div>
      </div>
    </div>
  </div>
</div>